"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.FileInput = void 0;
var component_button_1 = __importDefault(require("@doordash/component-button"));
var component_fields_1 = require("@doordash/component-fields");
var design_language_1 = require("@doordash/design-language");
var lodash_1 = require("lodash");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var FileInputWrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"
    /**
     * Used in FileInput to:
     * - hide the file input under its label
     * - ensure the input is still focusable
     * - make the label look interactive
     *   - label shows a pointer when hovered
     *   - label shows an outline when the input is focused
     */
])));
/**
 * Used in FileInput to:
 * - hide the file input under its label
 * - ensure the input is still focusable
 * - make the label look interactive
 *   - label shows a pointer when hovered
 *   - label shows an outline when the input is focused
 */
var FileInputHider = styled_components_1["default"](design_language_1.StackChildren)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  margin-top: ", "px;\n  padding: ", "px;\n\n  & > input {\n    width: 0.1px;\n    height: 0.1px;\n    opacity: 0;\n    overflow: hidden;\n    position: absolute;\n    z-index: -1;\n  }\n\n  & > label {\n    cursor: pointer;\n  }\n\n  & > input:focus + label > .outline-target,\n  & > input.has-focus + label > .outline-target {\n    ", "\n    border-radius: ", "px;\n  }\n"], ["\n  position: relative;\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  margin-top: ", "px;\n  padding: ", "px;\n\n  & > input {\n    width: 0.1px;\n    height: 0.1px;\n    opacity: 0;\n    overflow: hidden;\n    position: absolute;\n    z-index: -1;\n  }\n\n  & > label {\n    cursor: pointer;\n  }\n\n  & > input:focus + label > .outline-target,\n  & > input.has-focus + label > .outline-target {\n    ", "\n    border-radius: ", "px;\n  }\n"])), design_language_1.Colors.BorderPrimary, design_language_1.Spacing.XxxSmall, design_language_1.Spacing.XxxSmall, design_language_1.Spacing.XxSmall, design_language_1.getFocusStyles({ shouldUseFocusRing: false }), design_language_1.Spacing.XxxSmall);
var A11yLabelText = styled_components_1["default"].span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  left: -10000px;\n  width: 1px;\n  height: 1px;\n  display: inline;\n"], ["\n  position: absolute;\n  left: -10000px;\n  width: 1px;\n  height: 1px;\n  display: inline;\n"])));
var StyledImages = styled_components_1["default"].img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  max-width: 200px;\n"], ["\n  max-width: 200px;\n"])));
var isValidUrl = function (string) {
    try {
        return new URL(string);
    }
    catch (e) {
        return false;
    }
};
var FileInputValue = function (_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange;
    var renderedValue = value;
    var isUrl = isValidUrl(value);
    if (typeof value === 'object') {
        renderedValue = lodash_1.get(value, 'name');
    }
    if (isUrl) {
        renderedValue = isUrl.href.split('/').pop();
    }
    return (React.createElement(design_language_1.StackChildren, null,
        React.createElement(design_language_1.InlineChildren, { alignItems: design_language_1.InlineChildren.Alignment.Center }, isUrl ? (React.createElement(StyledImages, { src: isUrl.href, alt: renderedValue.toString() })) : (React.createElement(design_language_1.Text, { size: design_language_1.Text.Sizes.S14, style: { textDecoration: 'none' }, href: value }, renderedValue))),
        React.createElement(design_language_1.InlineChildren, null,
            React.createElement(component_button_1["default"], { size: component_button_1["default"].Sizes.Small, type: component_button_1["default"].Types.Secondary, isInline: true },
                React.createElement("label", { htmlFor: label }, FileInputButtonLabel.Replace)),
            React.createElement(component_button_1["default"], { onClick: function () { return onChange(null); }, size: component_button_1["default"].Sizes.Small, type: component_button_1["default"].Types.Tertiary, isInline: true },
                React.createElement(A11yLabelText, null, label),
                "Remove",
                React.createElement(A11yLabelText, null,
                    "selected file ",
                    renderedValue)))));
};
var FileInputButtonLabel;
(function (FileInputButtonLabel) {
    FileInputButtonLabel["Choose"] = "Choose a File";
    FileInputButtonLabel["Replace"] = "Replace";
    FileInputButtonLabel["Drop"] = "Drop File Here";
})(FileInputButtonLabel || (FileInputButtonLabel = {}));
var chooseFileLabel = function (value) {
    return value ? null : FileInputButtonLabel.Choose;
};
exports.FileInput = function (_a) {
    var value = _a.value, label = _a.label, error = _a.error, onChange = _a.onChange, _b = _a.fileAccepts, fileAccepts = _b === void 0 ? 'image/*' : _b;
    var inputRef = React.useRef(null);
    var _c = React.useState(chooseFileLabel(value)), buttonLabel = _c[0], setButtonLabel = _c[1];
    React.useEffect(function () {
        setButtonLabel(chooseFileLabel(value));
    }, [value, setButtonLabel]);
    var _d = React.useState(false), firefoxFocusTrick = _d[0], setFocusTrick = _d[1];
    var setFiles = function (files) {
        if (Boolean(files) && Boolean(files[0])) {
            onChange(files[0]);
        }
    };
    return (React.createElement(FileInputWrapper, null,
        React.createElement(design_language_1.Text, { tag: "label", styles: design_language_1.Text.Styles.Medium14 }, label),
        React.createElement(FileInputHider, null,
            React.createElement("input", { type: "file", name: label, id: label, onChange: function () { return setFiles(inputRef.current.files); }, ref: inputRef, accept: fileAccepts, onFocus: function () { return setFocusTrick(true); }, onBlur: function () { return setFocusTrick(false); }, className: firefoxFocusTrick ? 'has-focus' : '' }),
            React.createElement("label", { htmlFor: label, onDrop: function (e) {
                    e.preventDefault();
                    setFiles(e.dataTransfer.files);
                }, onDragEnter: function (e) { return setButtonLabel(FileInputButtonLabel.Drop); }, onDragLeave: function (e) { return setButtonLabel(chooseFileLabel(value)); }, onDragOver: function (e) {
                    // Necessary to enable drag and drop
                    e.preventDefault();
                } },
                React.createElement(A11yLabelText, null, label),
                React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.ContentAction, size: design_language_1.Text.Sizes.S14, className: "outline-target" }, buttonLabel)),
            value ? (React.createElement(FileInputValue, { label: label, value: value, onChange: onChange })) : null),
        error ? React.createElement(component_fields_1.ErrorMessage, null, error) : null));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
